import React, { useState, useEffect } from "react";
import "./TechnologyLandscape.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import KeyTechnologies from "./KeyTechnologies";
import IndustryTableComponent from "./industryTableComponent";
import { useDispatch, useSelector } from "react-redux";
import { fetchKeyTechnologiesRequest } from "../../../../store/features/actions/keyTechnologiesAction";
import { fetchTechlandScapeRequest } from "../../../../store/features/actions/techLandscapeActions";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";
import ContactCompSkeleton from "../../skeletons/contactSkeleton/contactCompSkeleton";

export default function TechnologyLandscape({ active_tab_key }) {

  const { account_info} = useSelector(state=>state?.accountsReducer)
  const company = account_info?.name; 
  const [keytechrecords, setKeyTechRecords] = useState([]);
  
  const [records, setRecords] = useState(null); // State to hold the API data
  const dispatch =  useDispatch();
  // Initialize separate sortConfig for each industry table with default sorting by supplier_name
  const [sortConfigs, setSortConfigs] = useState({}); 
   
  useEffect(() => {
    if (company) {
      dispatch(fetchTechlandScapeRequest(company));
      dispatch(fetchKeyTechnologiesRequest(company));
    }

  }, [account_info?.name])

  const {keyTechnologiesData,keyTechnologiesLoading,keyTechnologiesError} = useSelector(state=>state.keyTechnologiesReducer)
  const {techLandscapeData,techLandscapeLoading,techLandscapeError} = useSelector(state=>state.techLandscapeReducer)

  useEffect(() => {
    // Only fetch data when company is available
    if (!company) return;  

      try {   
        if (keyTechnologiesData && keyTechnologiesData.length > 0) {
          const companyKeyTechData = keyTechnologiesData[0].data || []; 
          setKeyTechRecords(companyKeyTechData); 
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }  

    if (active_tab_key !== 'technology') return;   
  }, [company, active_tab_key,keyTechnologiesLoading]);

  const renderTooltip = (title, use_case_text) => (
    <Tooltip className="custom-use-case-tooltip" placement="right">
      <b>{title}</b> {use_case_text}
    </Tooltip>
  );

  useEffect(() => {
    if (!company) return;

      try {
        const groupedData = techLandscapeData.reduce((acc, item) => {
          if (!acc[item.primary_industry]) {
            acc[item.primary_industry] = [];
          }
          acc[item.primary_industry].push(item);
          return acc;
        }, {});

        const sortedIndustries = Object.keys(groupedData)
          .sort((a, b) => groupedData[b].length - groupedData[a].length)
          .reduce((acc, industry) => {
            acc[industry] = groupedData[industry];
            return acc;
          }, {});

        setRecords(sortedIndustries); 
      } catch (error) {
        console.error("Error fetching data:", error);
      } 

    if (active_tab_key !== 'technology') return;

  }, [company,techLandscapeLoading]);

  // Handle sorting for each industry
  const sortData = (industry, column) => {
    const currentConfig = sortConfigs[industry] || { column: "", direction: "asc" };
    const newDirection = currentConfig.column === column && currentConfig.direction === "asc" ? "desc" : "asc";

    // Sort the records for the clicked industry
    const sortedIndustryRecords = [...records[industry]].sort((a, b) => {
      const valueA = a[column]?.toString().trim() || "";
      const valueB = b[column]?.toString().trim() || "";
      const comparison = valueA.localeCompare(valueB, undefined, { sensitivity: 'base' });

      return newDirection === "asc" ? comparison : -comparison;
    });

    // Update sort configuration and the sorted records for the industry
    setSortConfigs({
      ...sortConfigs,
      [industry]: { column, direction: newDirection },
    });

    setRecords({
      ...records,
      [industry]: sortedIndustryRecords,
    });
  };

  useEffect(() => {
    // Initialize the default sorting by supplier_name for all industries when the records are first fetched
    if (records && Object.keys(records).length > 0 && Object.keys(sortConfigs).length === 0) {
      const initialSortConfigs = Object.keys(records).reduce((acc, industry) => {
        acc[industry] = { column: "supplier_name", direction: "asc" };
        return acc;
      }, {});
      setSortConfigs(initialSortConfigs);

      // Sort the records initially by supplier_name
      const sortedBySupplierName = Object.keys(records).reduce((acc, industry) => {
        const sortedRecords = [...records[industry]].sort((a, b) => {
          const valueA = a.supplier_name?.toString().trim() || "";
          const valueB = b.supplier_name?.toString().trim() || "";
          return valueA.localeCompare(valueB, undefined, { sensitivity: 'base' });
        });
        acc[industry] = sortedRecords;
        return acc;
      }, {});
      setRecords(sortedBySupplierName);
    }
  }, [records, sortConfigs]);

  if ((!keyTechnologiesLoading || !techLandscapeLoading ) && (!records || Object.keys(records).length === 0)) {
    return null;
  }

  return (
    <>
      {keyTechnologiesLoading || techLandscapeLoading ? (
        <>
        <div className="container-fluid my-4 generic-table-skeleton"><ContactCompSkeleton numberOfCards={2}/></div>
          <GenericTableSkeleton rowCount={5} colCount={3} />
          <GenericTableSkeleton rowCount={5} colCount={4} />
          <GenericTableSkeleton rowCount={5} colCount={4} />
        </>
      ) : (
        <div className="col-md-12">
          <div className="container-fluid">
            {keytechrecords && keytechrecords.length > 0 && (
              <div className="technology_wrapper mt-4">
                <div className="head_top">
                  <h5 className="main_head">
                    Key Technologies
                    <span>
                      <OverlayTrigger
                        placement="right"
                        overlay={renderTooltip(
                          "",
                          "These insights are aggregated from multiple platforms along with user-contributed data and publicly available information, to map the technology stacks used by companies and teams."
                        )}
                      >
                        <h5 className="recent_head">
                          <i
                            className="fa fa-info-circle ml-2"
                            aria-hidden="true"
                            title=""
                          ></i>
                        </h5>
                      </OverlayTrigger>
                    </span>
                  </h5>
                </div>
                <KeyTechnologies techdata={keytechrecords} />
              </div>
            )}

            {Object.keys(records).map((industry) => (
              <IndustryTableComponent
                key={industry}
                industry={industry}
                records={records}
                sortConfigs={sortConfigs}
                sortData={sortData}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
